import React from 'react';
import { CheckSquare, Briefcase, Calendar, CalendarCheck } from 'lucide-react';

/**
 * Компонент дополнительных опций расчета
 */
const AdditionalOptionsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-cyan-50 dark:bg-cyan-900/20 p-5 rounded-lg border border-cyan-200 dark:border-cyan-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-cyan-500" />
        Дополнительные параметры
      </h3>
      
      <div className="space-y-4">
        {/* Учет только рабочих дней */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="countWorkingDaysOnly"
              checked={formData.countWorkingDaysOnly}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <Briefcase className="w-4 h-4 mr-1 text-cyan-500" />
              Учитывать только рабочие дни
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            При выборе этой опции, выходные дни (суббота и воскресенье) не будут учитываться в расчетах
          </p>
        </div>

        {/* Исключение праздников */}
        <div>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="excludeHolidays"
              checked={formData.excludeHolidays}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300 flex items-center">
              <CalendarCheck className="w-4 h-4 mr-1 text-cyan-500" />
              Исключить праздники из расчета
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Исключает государственные праздники и выходные дни из расчета рабочих дней
          </p>
        </div>

        {/* Настройки праздников, если они исключаются */}
        {formData.excludeHolidays && (
          <div className="ml-6 pt-2 border-t border-cyan-200 dark:border-cyan-800/50">
            <label className="inline-flex items-center mb-2">
              <input
                type="checkbox"
                name="useRussianHolidays"
                checked={formData.useRussianHolidays}
                onChange={handleInputChange}
                className="form-checkbox"
              />
              <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                Использовать российские государственные праздники
              </span>
            </label>
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-3">
              Включает все официальные праздники и выходные дни России
            </p>

            {!formData.useRussianHolidays && (
              <div className="py-2 px-3 bg-cyan-100 dark:bg-cyan-800/30 rounded text-sm text-cyan-700 dark:text-cyan-300">
                Чтобы добавить собственные праздничные дни, отключите использование российских праздников и укажите ваши даты в разделе ниже.
              </div>
            )}
          </div>
        )}

        {/* Подсчет конкретных дней недели */}
        <div className="pt-3 border-t border-cyan-200 dark:border-cyan-800/50">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="countSpecificDay"
              checked={formData.countSpecificDay}
              onChange={handleInputChange}
              className="form-checkbox"
              disabled={formData.calculationType !== 'difference'}
            />
            <span className={`ml-2 text-sm flex items-center ${
              formData.calculationType !== 'difference' 
                ? 'text-gray-400 dark:text-gray-500' 
                : 'text-gray-700 dark:text-gray-300'
            }`}>
              <Calendar className="w-4 h-4 mr-1 text-cyan-500" />
              Подсчитать количество определенных дней недели
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Например, сколько понедельников или пятниц содержится в выбранном периоде
          </p>
        </div>

        {/* Выбор дня недели если опция включена */}
        {formData.countSpecificDay && formData.calculationType === 'difference' && (
          <div className="ml-6 mt-3">
            <label htmlFor="specificDay" className="block text-sm text-gray-700 dark:text-gray-300 mb-1">
              День недели для подсчета:
            </label>
            <select
              id="specificDay"
              name="specificDay"
              value={formData.specificDay}
              onChange={handleInputChange}
              className="form-select w-full sm:w-auto"
            >
              <option value="1">Понедельник</option>
              <option value="2">Вторник</option>
              <option value="3">Среда</option>
              <option value="4">Четверг</option>
              <option value="5">Пятница</option>
              <option value="6">Суббота</option>
              <option value="0">Воскресенье</option>
            </select>
            {errors.specificDay && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.specificDay}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AdditionalOptionsSection;